module.exports = __webpack_public_path__ + "img/team-05.98616067.jpg";